import GalleryDetailForm from './galleryDetailForm.container'

export default GalleryDetailForm